/*
 * Copyright © 2026. Legalbird eine Marke der Legalbird GmbH
 */

import { useEffect, useState } from "react";
import { useCarousel } from "./CarouselProvider";
import { Box, Stack } from "@mui/material";
import { carouselDotsStyle } from "./carouselDotsStyle";
import Button from "@mui/material/Button";

export const CarouselDots = () => {
  const { carouselApi, id } = useCarousel();

  const [scrollSnaps, setScrollSnaps] = useState<number[] | null>([]);
  const [selectedSnap, setSelectedSnap] = useState(0);

  const goTo = (index: number) => carouselApi?.scrollTo(index);
  const setupSnaps = (api: typeof carouselApi) => setScrollSnaps(api?.scrollSnapList() ?? null);
  const setActiveSnap = (api: typeof carouselApi) => setSelectedSnap(api?.selectedScrollSnap() ?? 0);

  useEffect(() => {
    if (!carouselApi) {
      return;
    }

    setupSnaps(carouselApi);
    carouselApi.on("reInit", setupSnaps);
    carouselApi.on("reInit", setActiveSnap);
    carouselApi.on("select", setActiveSnap);

    return () => {
      carouselApi.off("reInit", setupSnaps);
      carouselApi.off("reInit", setActiveSnap);
      carouselApi.off("select", setActiveSnap);
    };
  }, [carouselApi]);

  return (
    <Stack direction={"row"} sx={{ gap: "0.5rem", justifyContent: "center", padding: "0.5rem 0" }} role={"group"} aria-label={"Carousel Pagination"}>
      {scrollSnaps?.map((_, index) => {
        const active = index === selectedSnap;

        return (
          <Button
            type={"button"}
            disableRipple
            aria-label={`Gehe zu Slide ${index + 1}`}
            aria-controls={id + "slide" + index}
            aria-current={active}
            disabled={active}
            key={index}
            onClick={() => goTo(index)}
            sx={[carouselDotsStyle.button, active ? carouselDotsStyle.activeButton : carouselDotsStyle.inactiveButton]}
          />
        );
      })}
    </Stack>
  );
};
